module.exports = __webpack_public_path__ + "static/img/Mitchell-Moses.8e1ac55.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Mitchell-Moses.jpg
// module id = AwUb
// module chunks = 0